export const UserQueryKeys = {
  GetUserInfo: () => ['userInfo']
}
